// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-sidebar {
  flex: 0 0 280px;
  width: 280px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  align-self: flex-start;
  position: sticky;
  top: 16px;
}
.user-sidebar__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
}
.user-sidebar__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #004195;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}
.user-sidebar__name {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #004195;
  line-height: 1.3;
}
.user-sidebar__role-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 999px;
  background: rgba(0, 48, 135, 0.08);
  color: #004195;
  font-size: 12px;
  font-weight: 600;
}
.user-sidebar__partner-badges {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.user-sidebar__divider {
  height: 1px;
  background: #e2e8f0;
  margin: 20px 0;
}
.user-sidebar__details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.user-sidebar__info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.user-sidebar__info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(0, 48, 135, 0.06);
  color: #004195;
}
.user-sidebar__info-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.user-sidebar__info-label {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #94a3b8;
}
.user-sidebar__info-value {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  word-break: break-word;
}
.user-sidebar__status-badge {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
}
.user-sidebar__status-badge--agent-id {
  background: #eff6ff;
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.2);
}
.user-sidebar__status-badge--active {
  background: #ecfdf5;
  color: #047857;
  box-shadow: inset 0 0 0 1px rgba(5, 150, 105, 0.2);
}
.user-sidebar__status-badge--inactive {
  background: #fff1f2;
  color: #be123c;
  box-shadow: inset 0 0 0 1px rgba(190, 18, 60, 0.2);
}
.user-sidebar__status-badge--verified {
  background: #ecfdf5;
  color: #047857;
  box-shadow: inset 0 0 0 1px rgba(5, 150, 105, 0.2);
}
.user-sidebar__status-badge--unverified {
  background: #fefce8;
  color: #a16207;
  box-shadow: inset 0 0 0 1px rgba(202, 138, 4, 0.2);
}

@media (max-width: 1024px) {
  .user-sidebar {
    flex: 1 1 100%;
    width: 100%;
    position: static;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserFormSidebar/userFormSidebar.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAIE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAHJ;AAME;EACE,WAAA;EACA,mBAAA;EACA,cAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALJ;AAQE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AAPJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAVJ;AAaE;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAXJ;AAaI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AAXN;AAcI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AAZN;AAeI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AAbN;AAgBI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AAdN;AAiBI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AAfN;;AAoBA;EACE;IACE,cAAA;IACA,WAAA;IACA,gBAAA;EAjBF;AACF","sourcesContent":[".user-sidebar {\n  flex: 0 0 280px;\n  width: 280px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 28px 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  align-self: flex-start;\n  position: sticky;\n  top: 16px;\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 10px;\n  }\n\n  &__avatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    background: #004195;\n    color: #fff;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__name {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    color: #004195;\n    line-height: 1.3;\n  }\n\n  &__role-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 14px;\n    border-radius: 999px;\n    background: rgba(0, 48, 135, 0.08);\n    color: #004195;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  &__partner-badges {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  &__divider {\n    height: 1px;\n    background: #e2e8f0;\n    margin: 20px 0;\n  }\n\n  &__details {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__info-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  &__info-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 32px;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    background: rgba(0, 48, 135, 0.06);\n    color: #004195;\n  }\n\n  &__info-content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  &__info-label {\n    font-size: 13px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #94a3b8;\n  }\n\n  &__info-value {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1e293b;\n    word-break: break-word;\n  }\n\n  &__status-badge {\n    display: inline-flex;\n    width: fit-content;\n    align-items: center;\n    border-radius: 999px;\n    padding: 2px 10px;\n    font-size: 12px;\n    font-weight: 600;\n\n    &--agent-id {\n      background: #eff6ff;\n      color: #1d4ed8;\n      box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.2);\n    }\n\n    &--active {\n      background: #ecfdf5;\n      color: #047857;\n      box-shadow: inset 0 0 0 1px rgba(5, 150, 105, 0.2);\n    }\n\n    &--inactive {\n      background: #fff1f2;\n      color: #be123c;\n      box-shadow: inset 0 0 0 1px rgba(190, 18, 60, 0.2);\n    }\n\n    &--verified {\n      background: #ecfdf5;\n      color: #047857;\n      box-shadow: inset 0 0 0 1px rgba(5, 150, 105, 0.2);\n    }\n\n    &--unverified {\n      background: #fefce8;\n      color: #a16207;\n      box-shadow: inset 0 0 0 1px rgba(202, 138, 4, 0.2);\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .user-sidebar {\n    flex: 1 1 100%;\n    width: 100%;\n    position: static;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
